document.addEventListener('DOMContentLoaded', setListenerOnProductGridItems);
document.addEventListener('BoaCollectionPageEvents', setListenerOnProductGridItems);
function setListenerOnProductGridItems(){
    const sizePopups = document.querySelectorAll('.product-grid .product-item-sizes-popup');
    sizePopups.forEach(popup=> popup.addEventListener('click', handleScrollSizes));
}
function handleScrollSizes(e){
    e.preventDefault()
    const arrowBtn = e.target;
    if(!arrowBtn?.classList.contains('arrow-btn')){
        return;
    }
    const sizesPopupEl = arrowBtn.closest('.product-item-sizes-popup');    
    const sizesWrapEl = sizesPopupEl?.querySelector('.product-item-sizes-wrap');
    if(!sizesWrapEl){
        return;
    }
    let { sizesAmount, currentPage } = sizesPopupEl.dataset;
    const maxPagesNum = calculateMaxNumOfPages(sizesAmount);
    currentPage = Number(currentPage);
    const itemHeight = sizesWrapEl?.children[0]?.offsetHeight ?? 0;
    const isArrowUp = arrowBtn.classList.contains('arrow-btn-up');

    if ((isArrowUp && currentPage <= 0) || (!isArrowUp && currentPage >= maxPagesNum)){
        return;
    }
    currentPage += isArrowUp ? -1 : 1;
    sizesPopupEl.dataset.currentPage = currentPage;
    const amountToMove = calculateItemsToShow(sizesAmount, currentPage);

    const finalAmount = amountToMove * itemHeight;
    sizesWrapEl.style.transform = `translateY(-${finalAmount}px)`;
    const arrowBtns = sizesPopupEl.querySelectorAll('.arrow-btn')
    toggleArrowBtns(arrowBtns, currentPage, maxPagesNum)
}

function calculateItemsToShow(itemsTotal, nextPage){
    return nextPage === 1 ? 0 : Math.min(itemsTotal, nextPage * 5) - 6;
}

function toggleArrowBtns([upBtn, downBtn], currentPage, maxPagesNum) {
    upBtn.classList.toggle('hidden-arrow', currentPage === 1);
    downBtn.classList.toggle('hidden-arrow', currentPage === maxPagesNum);
}

function calculateMaxNumOfPages(sizesNum){
    const itemsPerPage = 6;
    if(sizesNum <= itemsPerPage){
        return 1;
    }
    return Math.ceil((sizesNum - itemsPerPage) / 4) + 1;
}